<h1>{{'CONSENT_PREVIEW.ASK_FOR_CONSENT' | translate}}</h1>
<iframe *ngIf="consentUrl" [src]="consentUrl | safe" frameborder="0"></iframe>

<mat-accordion class="consent_scope">
  <mat-expansion-panel *ngFor="let scope of consentScopes; let i = index" [expanded]="step === i" (opened)="_showFields(i)" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-description>
        <span>
          <span class="icon"></span>
          <span class="scope_description"><b>{{scope?.scope}}</b>{{scope?.description}}</span>
        </span>
        <!-- <mat-icon [color]="'secondary'">info</mat-icon> -->
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-action-row>
      <ul class="fieldsList" *ngIf="required_fields_array.length > 0">
        <li><h3>{{'CONSENT_PREVIEW.REQUIRED_FIELDS' | translate}}</h3></li>
        <li *ngFor="let item of required_fields_array">
          <mat-checkbox [color]="'primary'" [disabled]="true" [checked]="true">{{item}}</mat-checkbox>
        </li>
      </ul>
      <ul class="fieldsList" *ngIf="scopesArray.length > 0">
        <li><h3>{{'CONSENT_PREVIEW.ALLOWED_FIELDS' | translate}}</h3></li>
        <li *ngFor="let item of scopesArray">
          <mat-checkbox [checked]="scopesArray.indexOf(item) > -1" (change)="_updateSelectedFields($event, item.field_name)">{{item?.name}}</mat-checkbox>
        </li>
      </ul>
    </mat-action-row>
  </mat-expansion-panel>
  </mat-accordion>

<div class="mat-error">
    {{errorMessage | translate}}
</div>

<div class="section btn-group">
    <a (click)="commonFunc.getRedirectedByRequestId()">{{'CANCEL' | translate}}</a>
    <app-button (clickEvent)="acceptConsent()" [btnOption]="buttonOptions.accept">
    </app-button>
</div>
